<template>
    <div class="not-found">
        <h1 class="not-found__title h1">404</h1>
        <div class="not-found__text copy">Seite konnte nicht gefunden werden</div>
        <router-link class="not-found__link" :to="{name: 'Main'}">
            <SmrButton class="not-found__button">Zum Routenplaner</SmrButton>
        </router-link>
    </div>
</template>

<script>
import SmrButton from '@/components/SmrButton'
export default {
    components: {
        SmrButton
    }
}
</script>

<style lang="scss">
.not-found {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    padding: 20px;

    &__title {
        font-size: 100px !important;
    }

    &__link {
        text-decoration: none;
    }

    &__button {
        margin-top: 20px;
        padding-right: 40px;
        padding-left: 40px;
    }
}
</style>

